import React from 'react';
import './Services.css';

const Services = () => {
  const coreTeams = [
    {
      title: 'Engineering & Innovation',
      description: 'Turning ideas into impact. Our engineers and designers build adaptive, engaging games that seniors can enjoy regardless of mobility, cognitive, or sensory challenges. By blending technology, creativity, and accessibility, we create solutions that make play inclusive for all. Our team designs, tests, and refines these games through hands-on collaboration with seniors to ensure they\'re fun, functional, and truly accessible.',
      video: '/videos/7475254-hd_1920_1080_25fps.mp4'
    },
    {
      title: 'Volunteering & Community Engagement',
      description: 'Because change happens face-to-face. Our volunteers bring energy, empathy, and engagement straight to seniors through interactive game nights, social events, and meaningful one-on-one connections. We organize and host these experiences in senior homes, ensuring that every event fosters real relationships, combats isolation, and promotes health.',
      video: '/videos/6646663-hd_1080_1920_24fps.mp4'
    },
    {
      title: 'Research & Awareness',
      description: 'Shining a light on untold stories. We dive deep into the realities of aging, tackling issues like isolation, ageism, accessibility, and intergenerational divides. Our team runs a monthly newsletter featuring interviews, insights, and stories that highlight the experiences of older adults, turning knowledge into action. We also collaborate with the Engineering team to ensure that research findings help shape better, more accessible games.',
      video: '/videos/6646679-hd_1080_1920_24fps.mp4'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">We're not waiting for change—we're creating it.</h2>
          <p className="section-subtitle">
            Our club is built on three core teams, each working toward a more inclusive future in unique ways.
          </p>
        </div>
        
        <div className="core-teams-grid">
          {coreTeams.map((team, index) => (
            <div key={index} className="team-card">
              <div className="team-video">
                <video 
                  src={team.video} 
                  className="team-bg-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
              <div className="team-content">
                <h3 className="team-title">{team.title}</h3>
                <p className="team-description">{team.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
